import { Compagnia } from './compagnia';
import { Model } from './model';

export class Gruppo extends Model {
  static apiUrl: string = "gruppi";

  nome: string;
  logo_path: string;
  giorni_automatismo_scadenza: number;
  compagnie: Compagnia[];

  deserialize(input: any): Gruppo {
    let retV: Gruppo = new Gruppo();

    retV = super.deserialize(input) as Gruppo;

    if (input?.compagnie) {
      retV.compagnie = input.compagnie.map(m => new Compagnia().deserialize(m));
    }


    return retV;
  }

}
